<template>
  <editForm
    :key="mappedCloseOption + '|' + formsid"
    :formsesid="formsid"
    :requiredsubmit="false"
    :closeoption="mappedCloseOption"
    :isfieldvalidate="showpopup"
    :showsignlist="isshowsignlist"
    :isPatientVisit="isPatientVisit"
    :isecrfform="true"
  />
</template>

<script src="./editecrffrom.js"></script>